import axios from "axios"

 const  baseUrl = axios.create({baseURL:"https://e-commerce-2-h08k.onrender.com"})
 export default baseUrl